import { render, staticRenderFns } from "./PartnerDetailCard.vue?vue&type=template&id=2183dd9b&scoped=true"
import script from "./PartnerDetailCard.vue?vue&type=script&lang=js"
export * from "./PartnerDetailCard.vue?vue&type=script&lang=js"
import style0 from "./PartnerDetailCard.vue?vue&type=style&index=0&id=2183dd9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183dd9b",
  null
  
)

export default component.exports